module.exports = __webpack_public_path__ + "static/media/helloLogo.5650d4fa.png";